import colors from './colors';

const BOX_SHADOW = {
  big: `0 10px 20px ${colors.grey2};`,
  small: `0 2px 4px ${colors.grey2};`,
};

export default BOX_SHADOW;
